import { Helmet } from "react-helmet-async"
import { SelectField } from "@sembark-travel/ui-form"
import { AuthLogsList } from "../../../AuthLogs"
import { SelectTenants } from "../../../Admin/Tenants"

export default function AuthLogsPage() {
	return (
		<>
			<Helmet>
				<title>Auth Logs</title>
			</Helmet>
			<AuthLogsList TenantsFilter={TenantsFilter} />
		</>
	)
}

function TenantsFilter() {
	return (
		<SelectField
			select={SelectTenants}
			name="tenants"
			label="Tenants"
			multiple
		/>
	)
}
